import { getModule } from '@/hooks/useRouteScope';
import { getCurrDataCenter, getUrlWorkspace } from '@/service';
import { GROUPS, PREFIX } from '@/service/apiConf';
import { get, putJSON } from '@/service/request';

import type { NotificationItem } from './index';

interface NotificationListResponse {
  items: NotificationItem[];
  unread: number;
}

export const UrlMap = () => {
  const model = getModule();
  const dc = getCurrDataCenter();
  const ws = getUrlWorkspace();
  const nsStr = model === 'data-center' ? `dc/${dc}` : `workspaces/${ws}`;
  return {
    watch: `${PREFIX.vapis(GROUPS.notice)}/${nsStr}/watch`,
    read: (uuid: string) => `${PREFIX.vapis(GROUPS.notice)}/${nsStr}/read/${uuid}`,
    list: `${PREFIX.vapis(GROUPS.notice)}/${nsStr}/notices`,
    readAll: `${PREFIX.vapis(GROUPS.notice)}/${nsStr}/readall`,
  };
};

// 监听消息
export function watch(params?: Record<string, any>) {
  return get<any>(UrlMap().watch, params);
}

// 已读消息
export function read(uuid: string) {
  return putJSON<void>(UrlMap().read(uuid), {});
}

// 标记为已读所有
export function readAll() {
  return putJSON<void>(UrlMap().readAll, {});
}

// 消息列表
export function getList(params?: Record<string, any>) {
  return get<NotificationListResponse>(UrlMap().list, params);
}
